(function(){
  var handle='untitled-nov-2-at-5-38-pm';
  var observedRoots=new WeakSet();
  var css=`
    .pve-eternelle-cart-item .pve-eternelle-cart-details{display:flex;flex-direction:column}
    .pve-eternelle-cart-item .upcart-product-title{order:0}
    .pve-eternelle-cart-item .upcart-product-title,
    .pve-eternelle-cart-item .upcart-product-title *{
      color:#111!important;-webkit-text-fill-color:#111!important;
      background:none!important;background-image:none!important;
      -webkit-background-clip:initial!important;background-clip:initial!important;
      opacity:1!important;text-shadow:none!important;
    }
    .pve-eternelle-cart-item .upcart-item-properties{order:1;margin:0!important}
    .pve-eternelle-cart-item .upcart-item-option{order:2}
    .pve-eternelle-cart-item .upcart-item-option,
    .pve-eternelle-cart-item .upcart-item-option *,
    .pve-eternelle-cart-item .upcart-item-properties,
    .pve-eternelle-cart-item .upcart-item-properties *{
      color:#111!important;-webkit-text-fill-color:#111!important;
      opacity:1!important;background:none!important;text-shadow:none!important;
      font-size:13px!important;line-height:1.45!important;letter-spacing:0!important;
    }
    .pve-eternelle-cart-item .upcart-item-property{margin:2px 0!important}
    .pve-eternelle-cart-item .upcart-item-property strong{font-weight:400!important}
    .pve-eternelle-cart-item .upcart-item-option.pve-option-duplicate{display:none!important}
  `;
  function normalize(value){return String(value||'').toLowerCase().replace(/[\s:_-]/g,'');}
  function updateRow(item){
    var link=item.querySelector('.upcart-product-title-link');
    if(!link)return;
    var path;
    try{path=new URL(link.getAttribute('href'),document.baseURI).pathname;}catch(error){return;}
    if(path.split('/products/')[1]!==handle)return;
    item.classList.add('pve-eternelle-cart-item');
    var title=item.querySelector('.upcart-product-title');
    if(title&&title.parentElement)title.parentElement.classList.add('pve-eternelle-cart-details');
    var properties=Array.from(item.querySelectorAll('.upcart-item-property')).map(function(property){
      var label=property.querySelector('strong');
      var value=property.querySelector('span');
      return {name:normalize(label&&label.textContent),value:String(value?value.textContent:'').trim()};
    });
    item.querySelectorAll('.upcart-item-option').forEach(function(option){
      var name=normalize(option.getAttribute('data-upcart-item-option-category'));
      var value=String(option.getAttribute('data-upcart-item-option-value')||'').trim();
      var duplicate=properties.some(function(property){return property.name===name&&property.value===value;});
      option.classList.toggle('pve-option-duplicate',duplicate);
    });
  }
  function attach(){
    var host=document.querySelector('#upCart');
    var root=host&&host.shadowRoot;
    if(!root||observedRoots.has(root))return;
    observedRoots.add(root);
    var style=document.createElement('style');
    style.id='purevella-eternelle-upcart';style.textContent=css;root.appendChild(style);
    function refresh(){root.querySelectorAll('.upcart-product-item').forEach(updateRow);}
    new MutationObserver(refresh).observe(root,{childList:true,subtree:true,characterData:true});
    refresh();
  }
  attach();
  new MutationObserver(attach).observe(document.documentElement,{childList:true,subtree:true});
})();
